import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import { BiData, TopNavMenuClickBiEvent } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import type { MenuItem } from '@wix/da-ds/pkg/Dropdown/MenuList';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';

export function usePrivacyPolicyItem(): MenuItem & { key: string } {
  const { t } = useTranslation();
  const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
  const isMobile = useContext(MobileContext);
  return {
    key: 'privacy-policy',
    label: t('siteHeader.userMenu.privacyPolicy'),
    link: Url.buildFromPath(URLS.PRIVACY),
    biData: BiData<TopNavMenuClickBiEvent>({
      evid: 702,
      link_url: Url.buildFromPath(URLS.PRIVACY),
      menu_item: 'privacy_policy',
      menu_name: 'profile',
    }),
    tabIndex: isUserMenuOpen || !isMobile ? 0 : -1,
  };
}
